<template>
  <div>
  <facit-header></facit-header>
    <div class="profile-div">
      <h5 class="mt-3 mb-5"> Add License </h5>
      <div class="login-div">
        <b-form @submit.prevent="register('formRegistration')"
                class="ml-4 mr-4 mb-4"
                data-vv-scope="formRegistration">
          <h5 class="mt-3 mb-3"> End User Details </h5>
          <b-form-group id="nameGroup">
            <b-row class="my-1">
              <b-col sm="6">
                <b-form-input id="firstname"
                            name="firstname"
                            type="text"
                            v-model="firstName"
                            v-validate="'required'"
                            :class="{'input': true,
                                      'is-danger': errors.has('formRegistration.firstname') }"
                            required
                            placeholder="First Name">
                </b-form-input>
                <i v-show="errors.has('formRegistration.firstname')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.firstname')"
                      class="help is-danger">{{ errors.first('formRegistration.firstname') }}
                </span>
              </b-col>
            <b-col sm="6">
                <b-form-input id="lastName"
                            name="lastname"
                            type="text"
                            v-model="lastName"
                            v-validate="'required'"
                            :class="{'input': true,
                                     'is-danger': errors.has('formRegistration.lastname') }"
                            required
                            placeholder="Last Name">
                </b-form-input>
                <i v-show="errors.has('formRegistration.lastname')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.lastname')"
                      class="help is-danger">{{ errors.first('formRegistration.lastname') }}
                </span>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group id="countryGroup">
            <b-row class="my-1">
              <b-col sm="6">
                <b-form-input id="companyName"
                            name="companyName"
                            type="text"
                            v-model="companyName"
                            v-validate="'required'"
                            :class="{'input': true,
                                     'is-danger': errors.has('formRegistration.companyName') }"
                            required
                            placeholder="Company Name">
                </b-form-input>
                <i v-show="errors.has('formRegistration.companyName')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.companyName')"
                      class="help is-danger">{{ errors.first('formRegistration.companyName') }}
                </span>
              </b-col>
            <b-col sm="6">
              <b-form-input id="street"
                          type="text"
                          name="street"
                          v-model="street"
                          v-validate="'required'"
                          :class="{'input': true,
                                   'is-danger': errors.has('formRegistration.street') }"
                          required
                          placeholder="Street">
               </b-form-input>
              <i v-show="errors.has('formRegistration.street')" class="fa fa-warning"></i>
              <span v-show="errors.has('formRegistration.street')"
                    class="help is-danger">{{ errors.first('formRegistration.street') }}
              </span>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group id="addressGroup">
            <b-row class="my-1">
              <b-col sm="6">
                <b-form-input id="state"
                            name="state"
                            type="text"
                            v-model="state"
                            v-validate="'required'"
                            :class="{'input': true,
                                     'is-danger': errors.has('formRegistration.state') }"
                            required
                            placeholder="State">
                </b-form-input>
                <i v-show="errors.has('formRegistration.state')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.state')"
                      class="help is-danger">{{ errors.first('formRegistration.state') }}
                </span>
              </b-col>
              <b-col sm="6">
                <b-form-input id="code"
                            name="code"
                            type="text"
                            v-model="code"
                            v-validate="'required'"
                            :class="{'input': true,
                                     'is-danger': errors.has('formRegistration.code') }"
                            required
                            placeholder="Zip Code">
                </b-form-input>
                <i v-show="errors.has('formRegistration.code')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.code')"
                      class="help is-danger">{{ errors.first('formRegistration.code') }}
                </span>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group id="emailGroup">
            <b-row class="my-1">
              <b-col sm="6">
                <b-form-input id="emailAddress"
                            type="email"
                            name="emailAddress"
                            v-model="emailAddress"
                            v-validate="'required|email'"
                            :class="{'input': true,
                                     'is-danger': errors.has('formRegistration.emailAddress') }"
                            required
                            placeholder="Email Address">
                </b-form-input>
                <i v-show="errors.has('formRegistration.emailAddress')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.emailAddress')"
                      class="help is-danger">{{ errors.first('formRegistration.emailAddress') }}
                </span>
              </b-col>
            <b-col sm="6">
                <b-form-input id="userClassification"
                            type="text"
                            name="userClassification"
                            v-model="userClassification"
                            :class="{'input': true,
                                     'is-danger': errors.has('formRegistration.userClassification') }"
                            required
                            placeholder="User Classification">
                </b-form-input>
                <i v-show="errors.has('formRegistration.userClassification')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.userClassification')"
                      class="help is-danger">{{ errors.first('formRegistration.userClassification') }}
                </span>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group id="packageGroup">
            <b-row class="my-1">
              <b-col sm="6">
                <b-form-select id="country"
                               name="country"
                               v-model="country"
                               :options="countries"
                               v-validate="'required'"
                               :class="{'input': true,
                                        'is-danger': errors.has('formRegistration.country') }"
                               required> </b-form-select>
                <i v-show="errors.has('formRegistration.country')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.country')"
                      class="help is-danger">{{ errors.first('formRegistration.country') }}
                </span>
                </b-col>
              <b-col sm="6">
                <b-form-select
                               v-model="packageId"
                               name="packageId"
                               v-validate="'required'"
                               :class="{'input': true,
                                        'is-danger': errors.has('formRegistration.packageId') }"
                               required>
                               <option value="null"> Select Package </option>
                               <option v-for="(list, index) in options"
                                       v-bind:key="index"
                                       :value="{id: list.id, totalCost: list.totalCost, name: list.packageName}">
                                 {{ list.packageName }}
                               </option>
                </b-form-select>
                <i v-show="errors.has('formRegistration.packageId')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.packageId')"
                      class="help is-danger">{{ errors.first('formRegistration.packageId') }}
                </span>
              </b-col>
            </b-row>
          </b-form-group>
		  
		  
          <b-form-group id="dateGroup">
            <b-row class="my-1">
              <b-col sm="6">
                <input class="form-control" type="date" v-model="datePickerVal" />
                </b-col>
            </b-row>
          </b-form-group>
		  
          <h5 class="mt-4 mb-4"> Reseller Details </h5>
          <b-form-group id="nameGroup">
            <b-row class="my-1">
              <b-col sm="6">
                <b-form-input id="resellerFirstname"
                            name="resellerFirstname"
                            type="text"
                            v-model="resellerFirstname"
                            v-validate="'required'"
                            :class="{'input': true,
                                      'is-danger': errors.has('formRegistration.resellerFirstname') }"
                            required
                            placeholder="First Name">
                </b-form-input>
                <i v-show="errors.has('formRegistration.resellerFirstname')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.resellerFirstname')"
                      class="help is-danger">{{ errors.first('formRegistration.resellerFirstname') }}
                </span>
              </b-col>
            <b-col sm="6">
                <b-form-input id="resellerLastname"
                            name="resellerLastname"
                            type="text"
                            v-model="resellerLastname"
                            v-validate="'required'"
                            :class="{'input': true,
                                     'is-danger': errors.has('formRegistration.resellerLastname') }"
                            required
                            placeholder="Last Name">
                </b-form-input>
                <i v-show="errors.has('formRegistration.resellerLastname')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.resellerLastname')"
                      class="help is-danger">{{ errors.first('formRegistration.resellerLastname') }}
                </span>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group id="countryGroup">
            <b-row class="my-1">
              <b-col sm="6">
                <b-form-input id="resellerCompanyName"
                            name="resellerCompanyName"
                            type="text"
                            v-model="resellerCompanyName"
                            v-validate="'required'"
                            :class="{'input': true,
                                     'is-danger': errors.has('formRegistration.resellerCompanyName') }"
                            required
                            placeholder="Company Name">
                </b-form-input>
                <i v-show="errors.has('formRegistration.resellerCompanyName')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.resellerCompanyName')"
                      class="help is-danger">{{ errors.first('formRegistration.resellerCompanyName') }}
                </span>
              </b-col>
            <b-col sm="6">
              <b-form-input id="resellerStreet"
                          type="text"
                          name="resellerStreet"
                          v-model="resellerStreet"
                          v-validate="'required'"
                          :class="{'input': true,
                                   'is-danger': errors.has('formRegistration.resellerStreet') }"
                          required
                          placeholder="Street">
               </b-form-input>
              <i v-show="errors.has('formRegistration.resellerStreet')" class="fa fa-warning"></i>
              <span v-show="errors.has('formRegistration.resellerStreet')"
                    class="help is-danger">{{ errors.first('formRegistration.resellerStreet') }}
              </span>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group id="addressGroup">
            <b-row class="my-1">
              <b-col sm="6">
                <b-form-input id="resellerState"
                            name="resellerState"
                            type="text"
                            v-model="resellerState"
                            v-validate="'required'"
                            :class="{'input': true,
                                     'is-danger': errors.has('formRegistration.resellerState') }"
                            required
                            placeholder="State">
                </b-form-input>
                <i v-show="errors.has('formRegistration.resellerState')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.resellerState')"
                      class="help is-danger">{{ errors.first('formRegistration.resellerState') }}
                </span>
              </b-col>
              <b-col sm="6">
                <b-form-input id="resellerCode"
                            name="resellerCode"
                            type="text"
                            v-model="resellerCode"
                            v-validate="'required'"
                            :class="{'input': true,
                                     'is-danger': errors.has('formRegistration.resellerCode') }"
                            required
                            placeholder="Zip Code">
                </b-form-input>
                <i v-show="errors.has('formRegistration.resellerCode')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.resellerCode')"
                      class="help is-danger">{{ errors.first('formRegistration.resellerCode') }}
                </span>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group id="emailGroup">
            <b-row class="my-1">
              <b-col sm="6">
                <b-form-input id="resellerEmail"
                            type="email"
                            name="resellerEmail"
                            v-model="resellerEmail"
                            v-validate="'required|email'"
                            :class="{'input': true,
                                     'is-danger': errors.has('formRegistration.resellerEmail') }"
                            required
                            placeholder="Email Address">
                </b-form-input>
                <i v-show="errors.has('formRegistration.resellerEmail')" class="fa fa-warning"></i>
                <span v-show="errors.has('formRegistration.resellerEmail')"
                      class="help is-danger">{{ errors.first('formRegistration.resellerEmail') }}
                </span>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group id="recaptchaGroup">
            <b-row class="my-1">
              <b-col sm="12">
                <vue-recaptcha
                  ref="recaptcha"
                  @verify="onVerify"
                  @expired="onExpired"
                  sitekey="6LfNiFMUAAAAAIvrde8Hq-aeNyI-OA5R30sKrLJv">
                </vue-recaptcha>
              </b-col>
            </b-row>
          </b-form-group>
          <b-button
            type="submit"
            class="w-100"
            :disabled="disabledButton"
            variant="warning">Complete Registration</b-button>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import FacitHeader from '@/components/header';
import VueRecaptcha from 'vue-recaptcha';
import moment from 'moment';

export default {
  name: 'registerUser',
  components: { FacitHeader, VueRecaptcha },
  data() {
    const userData = Session.getAccessToken().user;
    const userId = userData.id;
    const currentTimeStamp = moment().unix();
    return {
      email: `${currentTimeStamp}@facitdatasystems.com`,
	  datePickerVal: this.getTodayDate(),
      password: null,
      firstName: null,
      lastName: null,
      confirmEmail: null,
      confirmPassword: null,
      disabledButton: true,
      companyName: null,
      address: null,
      code: null,
      country: null,
      createdBy: userId,
      options: null,
      packageId: null,
      state: null,
      street: null,
      emailAddress: null,
      resellerEmail:null,
      resellerCode:null,
      resellerState:null,
      resellerStreet:null,
      resellerFirstname:null,
      resellerLastname:null,
      resellerCompanyName:null,
      userClassification:null,
      countries: [
        { value: null, text: 'Select Country' },
        { value: 'Afghanistan', text: 'Afghanistan' },
        { value: 'Åland Islands', text: 'Åland Islands' },
        { value: 'Albania', text: 'Albania' },
        { value: 'Algeria', text: 'Algeria' },
        { value: 'American Samoa', text: 'American Samoa' },
        { value: 'Andorra', text: 'Andorra' },
        { value: 'Angola', text: 'Angola' },
        { value: 'Anguilla', text: 'Anguilla' },
        { value: 'Antarctica', text: 'Antarctica' },
        { value: 'Argentina', text: 'Argentina' },
        { value: 'Armenia', text: 'Armenia' },
        { value: 'Aruba', text: 'Aruba' },
        { value: 'Australia', text: 'Australia' },
        { value: 'Austria', text: 'Austria' },
        { value: 'Azerbaijan', text: 'Azerbaijan' },
        { value: 'Bahamas', text: 'Bahamas' },
        { value: 'Bahrain', text: 'Bahrain' },
        { value: 'Bangladesh', text: 'Bangladesh' },
        { value: 'Barbados', text: 'Barbados' },
        { value: 'Belarus', text: 'Belarus' },
        { value: 'Belgium', text: 'Belgium' },
        { value: 'Belize', text: 'Belize' },
        { value: 'Benin', text: 'Benin' },
        { value: 'Bermuda', text: 'Bermuda' },
        { value: 'Bhutan', text: 'Bhutan' },
        { value: 'Bosnia and Herzegovina', text: 'Bosnia and Herzegovina' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Brunei Darussalam', text: 'Brunei Darussalam' },
        { value: 'Bulgaria', text: 'Bulgaria' },
        { value: 'Burkina Faso', text: 'Burkina Faso' },
        { value: 'Burundi', text: 'Burundi' },
        { value: 'Cambodia', text: 'Cambodia' },
        { value: 'Cameroon', text: 'Cameroon' },
        { value: 'Canada', text: 'Canada' },
        { value: 'Central African Republic', text: 'Central African Republic' },
        { value: 'Chad', text: 'Chad' },
        { value: 'Chile', text: 'Chile' },
        { value: 'China', text: 'China' },
        { value: 'Colombia', text: 'Colombia' },
        { value: 'Congo', text: 'Congo' },
        { value: 'Cook Islands', text: 'Cook Islands' },
        { value: 'Costa Rica', text: 'Costa Rica' },
        { value: 'Côte d`Ivoire', text: 'Côte d`Ivoire' },
        { value: 'Croatia', text: 'Croatia' },
        { value: 'Cuba', text: 'Cuba' },
        { value: 'Cyprus', text: 'Cyprus' },
        { value: 'Czech Republic', text: 'Czech Republic' },
        { value: 'Denmark', text: 'Denmark' },
        { value: 'Dominica', text: 'Dominica' },
        { value: 'Dominican Republic', text: 'Dominican Republic' },
        { value: 'Ecuador', text: 'Ecuador' },
        { value: 'Egypt', text: 'Egypt' },
        { value: 'Eritrea', text: 'Eritrea' },
        { value: 'Estonia', text: 'Estonia' },
        { value: 'Ethiopia', text: 'Ethiopia' },
        { value: 'Fiji', text: 'Fiji' },
        { value: 'Finland', text: 'Finland' },
        { value: 'France', text: 'France' },
        { value: 'Gabon', text: 'Gabon' },
        { value: 'Gambia', text: 'Gambia' },
        { value: 'Georgia', text: 'Georgia' },
        { value: 'Germany', text: 'Germany' },
        { value: 'Ghana', text: 'Ghana' },
        { value: 'Gibraltar', text: 'Gibraltar' },
        { value: 'Greece', text: 'Greece' },
        { value: 'Greenland', text: 'Greenland' },
        { value: 'Grenada', text: 'Grenada' },
        { value: 'Guadeloupe', text: 'Guadeloupe' },
        { value: 'Guam', text: 'Guam' },
        { value: 'Guatemala', text: 'Guatemala' },
        { value: 'Guernsey', text: 'Guernsey' },
        { value: 'Guinea', text: 'Guinea' },
        { value: 'Guinea-Bissau', text: 'Guinea-Bissau' },
        { value: 'Guyana', text: 'Guyana' },
        { value: 'Haiti', text: 'Haiti' },
        { value: 'Honduras', text: 'Honduras' },
        { value: 'Hong Kong', text: 'Hong Kong' },
        { value: 'Hungary', text: 'Hungary' },
        { value: 'Iceland', text: 'Iceland' },
        { value: 'India', text: 'India' },
        { value: 'Indonesia', text: 'Indonesia' },
        { value: 'Islamic Republic of Iran', text: 'Islamic Republic of Iran' },
        { value: 'Iraq', text: 'Iraq' },
        { value: 'Ireland', text: 'Ireland' },
        { value: 'Israel', text: 'Israel' },
        { value: 'Italy', text: 'Italy' },
        { value: 'Jamaica', text: 'Jamaica' },
        { value: 'Japan', text: 'Japan' },
        { value: 'Jersey', text: 'Jersey' },
        { value: 'Jordan', text: 'Jordan' },
        { value: 'Kazakhstan', text: 'Kazakhstan' },
        { value: 'Kenya', text: 'Kenya' },
        { value: 'Kiribati', text: 'Kiribati' },
        { value: 'Democratic People`s Republic of Korea', text: 'Democratic People`s Republic of Korea' },
        { value: 'Republic of Korea', text: 'Republic of Korea' },
        { value: 'Kuwait', text: 'Kuwait' },
        { value: 'Kyrgyzstan', text: 'Kyrgyzstan' },
        { value: 'Latvia', text: 'Latvia' },
        { value: 'Lebanon', text: 'Lebanon' },
        { value: 'Lesotho', text: 'Lesotho' },
        { value: 'Liberia', text: 'Liberia' },
        { value: 'Libya', text: 'Libya' },
        { value: 'Liechtenstein', text: 'Liechtenstein' },
        { value: 'Lithuania', text: 'Lithuania' },
        { value: 'Luxembourg', text: 'Luxembourg' },
        { value: 'Macao', text: 'Macao' },
        { value: 'Madagascar', text: 'Madagascar' },
        { value: 'Malawi', text: 'Malawi' },
        { value: 'Malaysia', text: 'Malaysia' },
        { value: 'Maldives', text: 'Maldives' },
        { value: 'Mali', text: 'Mali' },
        { value: 'Malta', text: 'Malta' },
        { value: 'Marshall Islands', text: 'Marshall Islands' },
        { value: 'Martinique', text: 'Martinique' },
        { value: 'Mauritania', text: 'Mauritania' },
        { value: 'Mauritius', text: 'Mauritius' },
        { value: 'Mayotte', text: 'Mayotte' },
        { value: 'Mexico', text: 'Mexico' },
        { value: 'Micronesia', text: 'Micronesia' },
        { value: 'Moldova', text: 'Moldova' },
        { value: 'Monaco', text: 'Monaco' },
        { value: 'Mongolia', text: 'Mongolia' },
        { value: 'Montenegro', text: 'Montenegro' },
        { value: 'Montserrat', text: 'Montserrat' },
        { value: 'Morocco', text: 'Morocco' },
        { value: 'Mozambique', text: 'Mozambique' },
        { value: 'Myanmar', text: 'Myanmar' },
        { value: 'Namibia', text: 'Namibia' },
        { value: 'Nauru', text: 'Nauru' },
        { value: 'Nepal', text: 'Nepal' },
        { value: 'Netherlands', text: 'Netherlands' },
        { value: 'New Caledonia', text: 'New Caledonia' },
        { value: 'New Zealand', text: 'New Zealand' },
        { value: 'Nicaragua', text: 'Nicaragua' },
        { value: 'Niger', text: 'Niger' },
        { value: 'Nigeria', text: 'Nigeria' },
        { value: 'Niue', text: 'Niue' },
        { value: 'Norfolk Island', text: 'Norfolk Island' },
        { value: 'Northern Mariana Islands', text: 'Northern Mariana Islands' },
        { value: 'Norway', text: 'Norway' },
        { value: 'Oman', text: 'Oman' },
        { value: 'Pakistan', text: 'Pakistan' },
        { value: 'Palau', text: 'Palau' },
        { value: 'Palestine', text: 'Palestine' },
        { value: 'Panama', text: 'Panama' },
        { value: 'Papua New Guinea', text: 'Papua New Guinea' },
        { value: 'Paraguay', text: 'Paraguay' },
        { value: 'Peru', text: 'Peru' },
        { value: 'Philippines', text: 'Philippines' },
        { value: 'Pitcairn', text: 'Pitcairn' },
        { value: 'Poland', text: 'Poland' },
        { value: 'Portugal', text: 'Portugal' },
        { value: 'Puerto Rico', text: 'Puerto Rico' },
        { value: 'Qatar', text: 'Qatar' },
        { value: 'Réunion', text: 'Réunion' },
        { value: 'Romania', text: 'Romania' },
        { value: 'Russian Federation', text: 'Russian Federation' },
        { value: 'Rwanda', text: 'Rwanda' },
        { value: 'Saint Barthélemy', text: 'Saint Barthélemy' },
        { value: 'Saint Helena', text: 'Saint Helena, Ascension and Tristan da Cunha' },
        { value: 'Saint Kitts and Nevis', text: 'Saint Kitts and Nevis' },
        { value: 'Saint Lucia', text: 'Saint Lucia' },
        { value: 'Saint Pierre and Miquelon', text: 'Saint Pierre and Miquelon' },
        { value: 'Saint Vincent and the Grenadines', text: 'Saint Vincent and the Grenadines' },
        { value: 'Samoa', text: 'Samoa' },
        { value: 'San Marino', text: 'San Marino' },
        { value: 'Sao Tome and Principe', text: 'Sao Tome and Principe' },
        { value: 'Saudi Arabia', text: 'Saudi Arabia' },
        { value: 'Senegal', text: 'Senegal' },
        { value: 'Serbia', text: 'Serbia' },
        { value: 'Seychelles', text: 'Seychelles' },
        { value: 'Sierra Leone', text: 'Sierra Leone' },
        { value: 'Singapore', text: 'Singapore' },
        { value: 'Sint Maarten', text: 'Sint Maarten' },
        { value: 'Slovakia', text: 'Slovakia' },
        { value: 'Slovenia', text: 'Slovenia' },
        { value: 'Solomon Islands', text: 'Solomon Islands' },
        { value: 'Somalia', text: 'Somalia' },
        { value: 'South Africa', text: 'South Africa' },
        { value: 'South Sudan', text: 'South Sudan' },
        { value: 'Spain', text: 'Spain' },
        { value: 'Sri Lanka', text: 'Sri Lanka' },
        { value: 'Sudan', text: 'Sudan' },
        { value: 'Suriname', text: 'Suriname' },
        { value: 'Swaziland', text: 'Swaziland' },
        { value: 'Sweden', text: 'Sweden' },
        { value: 'Switzerland', text: 'Switzerland' },
        { value: 'Syrian Arab Republic', text: 'Syrian Arab Republic' },
        { value: 'Taiwan', text: 'Taiwan' },
        { value: 'Tajikistan', text: 'Tajikistan' },
        { value: 'Tanzania', text: 'Tanzania' },
        { value: 'Thailand', text: 'Thailand' },
        { value: 'Timor-Leste', text: 'Timor-Leste' },
        { value: 'Togo', text: 'Togo' },
        { value: 'Tokelau', text: 'Tokelau' },
        { value: 'Tonga', text: 'Tonga' },
        { value: 'Trinidad and Tobago', text: 'Trinidad and Tobago' },
        { value: 'Tunisia', text: 'Tunisia' },
        { value: 'Turkey', text: 'Turkey' },
        { value: 'Turkmenistan', text: 'Turkmenistan' },
        { value: 'Tuvalu', text: 'Tuvalu' },
        { value: 'Uganda', text: 'Uganda' },
        { value: 'Ukraine', text: 'Ukraine' },
        { value: 'United Arab Emirates', text: 'United Arab Emirates' },
        { value: 'United Kingdom', text: 'United Kingdom' },
        { value: 'United States', text: 'United States' },
        { value: 'Uruguay', text: 'Uruguay' },
        { value: 'Uzbekistan', text: 'Uzbekistan' },
        { value: 'Vanuatu', text: 'Vanuatu' },
        { value: 'Venezuela', text: 'Venezuela' },
        { value: 'Viet Nam', text: 'Viet Nam' },
        { value: 'Virgin Islands, British', text: 'Virgin Islands, British' },
        { value: 'Virgin Islands, U.S.', text: 'Virgin Islands, U.S.' },
        { value: 'Wallis and Futuna', text: 'Wallis and Futuna' },
        { value: 'Western Sahara', text: 'Western Sahara' },
        { value: 'Yemen', text: 'Yemen' },
        { value: 'Zambia', text: 'Zambia' },
        { value: 'Zimbabwe', text: 'Zimbabwe' },
      ],
    };
  },
  created() {
    this.getPackage();
    const customMessage = {
    custom: {
      emailAddress: {
        required: 'The Email Field is Required',
      },
      password: {
        required: 'The Password is Required',
      },
      firstname: {
        required: 'The First Name is Required'
      },
      lastname: {
        required: 'The Last Name is Required'
      },
      companyName: {
        required: 'The Company Name is Required'
      },
      code: {
        required: 'The Zip Code is Required'
      },
      street: {
        required: 'The Street Field is Required'
      },
      state: {
        required: 'The State Field is Required'
      },
      userClassification: {
        required: 'The User Classification Field is Required'
      },
      resellerCompanyName: {
        required: 'The Company Name Field is Required'
      },
      resellerStreet: {
        required: 'The Street Field is Required'
      },
      resellerState: {
        required: 'The State Field is Required'
      },
      resellerCode: {
        required: 'The Zip Code Field is Required'
      },
      resellerFirstname: {
        required: 'The First Name Field is Required'
      },
      resellerLastname: {
        required: 'The Last Name Field is Required'
      },
      packageId: {
        required: 'Please select package',
      },
    },
  };
  this.$validator.localize('en', customMessage);
  },
  methods: {
   getTodayDate() {
      const today = new Date();
      const yyyy = today.getFullYear()+1;
      const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const dd = String(today.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    async register(scope) {
      try {
        const validation = await this.$validator.validateAll(scope);
        if (validation) {
          let cost = 1
          if (this.packageId.name === 'IC2020-ENTERRPRISE') {
            cost = 60000
          } else if (this.packageId.name === 'IC2020-EDUCATION') {
            cost = 5000
          } else {
            cost = this.packageId.totalCost
          }
          const emailAddress = this.email.toLowerCase()
          const account = await API.post('Accounts', {
            email: emailAddress,
            password: 'password',
            purchased: true,
            firstname: this.firstName,
            lastname: this.lastName,
            address: this.address,
            postcode: this.code,
            companyname: this.companyName,
            country: this.country,
            billingEmail: emailAddress,
            registrationType: 0,
            packageId: this.packageId.id,
            createdBy: this.createdBy,
            totalDevices: 1,
            credits: cost,
            trialLimit: -8,
            accountType: 1,
            endUserStreet: this.street,
            endUserState: this.state,
            endUserEmail: this.emailAddress,
            endUserClassification: this.userClassification,
            resellerCompany: this.resellerCompanyName,
            resellerStreet: this.resellerStreet,
            resellerState: this.resellerState,
            resellerCode: this.resellerCode,
            resellerFirstName: this.resellerFirstname,
            resellerLastName: this.resellerLastname,
            resellerEmail: this.resellerEmail,
			expiryDate: this.datePickerVal,
          });
          this.$notify({
            group: 'sitewide',
            title: 'Success!',
            type: 'success',
            text: 'User added successfully',
          });
          this.$router.push('userList');
        }
      } catch (error) {
        const message = error.response.data.error.message;
        if (message.match(/email already exists/gi)) {
          this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Email already exists',
          });
        }
      }
    },
    async onVerify(response) {
      if (response) {
        this.disabledButton = false;
      }
    },
    onExpired() {

    },
    async getPackage() {
      try {
        const token = Session.getAccessToken();
        const userId = token.user.id;
        const packageList = await API.get(`PackageLists/?filter={"where":{"userId":"${userId}"}}`);
          this.options = packageList
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #d6700a;
}

input:focus + .slider {
  box-shadow: 0 0 1px #d6700a;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}
.switch input {
  display:none;
}
</style>



// WEBPACK FOOTER //
// src/components/registerUser.vue